// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { pluralize } from "@turnerBlueprint/XDL/Utilities";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageTitle: getCurrentPage(state).fields.title,
    cart: getCurrentCartState(state).value,
});

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

export interface RfqRequestQuoteHeaderStyles {
    titleText?: TypographyPresentationProps;
    // XNG-Changes
    wrapper?: InjectableCss;
    lineCountStyles?: TypographyPresentationProps;
}

export const rfqRequestQuoteHeaderStyles: RfqRequestQuoteHeaderStyles = {
    titleText: {
        variant: "h2",
    },
};

const styles = rfqRequestQuoteHeaderStyles;

const RfqRequestQuoteHeader: FC<Props> = ({ pageTitle, cart }) => {
    if (!cart) {
        return null;
    }

    // XNG-Changes
    const cartLines = cart.cartLines;

    const title = cart.isSalesperson ? pageTitle.replace("Request", "Create") : pageTitle;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText} as="h1" data-test-selector="requestQuoteHeader">
                {title}
            </Typography>
            {/* XNG-Changes: adding linecounts + adding cartLines.length condition */}
            {cartLines && cartLines.length > 0 && (
                <Typography {...styles.lineCountStyles}>
                    {pluralize(cartLines.length, translate("Item"), { showNumber: true })}
                </Typography>
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqRequestQuoteHeader),
    definition: {
        group: "RFQ Request Quote",
        displayName: "Header",
        allowedContexts: ["RfqRequestQuotePage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
